import React from 'react';

const SignUpError = () => (
  <div className="mb-4 text-pink-500 font-semibold text-2xl">
    It seems something went wrong... Would you like to try again?
  </div>
);

export default SignUpError;
